export enum FilterGroupType {
  Spatial = 'Spatial',
  General = 'General'
}
